var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inquiry_main"},[_c('p',{staticClass:"current"},[_vm._v("当前位置："),_c('span',[_vm._v("报价")])]),_c('div',{staticClass:"inquiry_info"})])
}]

export { render, staticRenderFns }